import { render, staticRenderFns } from "./pickupTour.vue?vue&type=template&id=38c3e002&scoped=true"
import script from "./pickupTour.vue?vue&type=script&lang=js"
export * from "./pickupTour.vue?vue&type=script&lang=js"
import style0 from "./pickupTour.vue?vue&type=style&index=0&id=38c3e002&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3e002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c3e002')) {
      api.createRecord('38c3e002', component.options)
    } else {
      api.reload('38c3e002', component.options)
    }
    module.hot.accept("./pickupTour.vue?vue&type=template&id=38c3e002&scoped=true", function () {
      api.rerender('38c3e002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/pickupTour.vue"
export default component.exports